import { render, staticRenderFns } from "./we.vue?vue&type=template&id=2a0f113a&scoped=true"
import script from "./we.vue?vue&type=script&lang=js"
export * from "./we.vue?vue&type=script&lang=js"
import style0 from "./we.vue?vue&type=style&index=0&id=2a0f113a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a0f113a",
  null
  
)

export default component.exports